import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withKeys as _withKeys, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/logo.jpg'
import _imports_1 from '../assets/Zalo.png'


const _hoisted_1 = { class: "flex min-h-screen items-center justify-center bg-slate-100 p-5" }
const _hoisted_2 = { class: "grid w-full max-w-[980px] overflow-hidden rounded-2xl bg-white shadow-[0_24px_70px_rgba(15,23,42,0.22)] md:grid-cols-[0.95fr_1.05fr]" }
const _hoisted_3 = { class: "flex items-center justify-center p-8" }
const _hoisted_4 = { class: "w-full max-w-[360px]" }
const _hoisted_5 = { class: "mb-4" }
const _hoisted_6 = { class: "mb-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Password = _resolveComponent("Password")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[8] || (_cache[8] = _createStaticVNode("<div class=\"flex min-h-[520px] items-center justify-center bg-[linear-gradient(135deg,#0f766e_0%,#155e75_100%)] p-8 text-white\"><div class=\"flex max-w-[320px] flex-col items-center text-center\"><img src=\"" + _imports_0 + "\" alt=\"Logo\" class=\"h-28 w-28 rounded-2xl bg-white object-contain p-2 shadow-xl\"><h2 class=\"mt-5 text-3xl font-black\">Phường Hương Trà</h2><p class=\"mt-2 text-sm font-semibold text-white/80\"> Thành phố Đà Nẵng </p><div class=\"my-6 h-px w-24 bg-white/30\"></div><div class=\"flex items-center gap-3 rounded-full bg-white/10 px-4 py-3 text-sm font-bold\"><img src=\"" + _imports_1 + "\" alt=\"Zalo\" class=\"h-8 w-8 rounded-lg bg-white object-contain\"><span>Hệ thống nhắn tin Zalo OA</span></div></div></div>", 1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[6] || (_cache[6] = _createElementVNode("div", { class: "mb-7 text-center" }, [
            _createElementVNode("div", { class: "mb-3 inline-flex h-12 w-12 items-center justify-center rounded-full bg-teal-50" }, [
              _createElementVNode("i", { class: "pi pi-lock text-xl text-teal-700 leading-none" })
            ]),
            _createElementVNode("h3", null, "Đăng nhập hệ thống"),
            _createElementVNode("p", null, "Vui lòng nhập thông tin tài khoản của bạn")
          ], -1)),
          _createElementVNode("div", _hoisted_5, [
            _cache[4] || (_cache[4] = _createElementVNode("label", { for: "username" }, [
              _createElementVNode("span", { class: "pi pi-user mr-2 text-teal-700" }),
              _createTextVNode(" Tên đăng nhập ")
            ], -1)),
            _createVNode(_component_InputText, {
              id: "username",
              type: "text",
              modelValue: $setup.userName,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.userName) = $event)),
              placeholder: "Nhập tên đăng nhập",
              class: "w-full",
              autocomplete: "username"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _cache[5] || (_cache[5] = _createElementVNode("label", { for: "password" }, [
              _createElementVNode("span", { class: "pi pi-key mr-2 text-teal-700" }),
              _createTextVNode(" Mật khẩu ")
            ], -1)),
            _createVNode(_component_Password, {
              id: "password",
              modelValue: $setup.password,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.password) = $event)),
              placeholder: "Nhập mật khẩu",
              class: "w-full",
              toggleMask: true,
              onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => ($setup.doLogin()), ["enter"]))
            }, null, 8, ["modelValue"])
          ]),
          _createVNode(_component_Button, {
            label: "Đăng nhập",
            icon: "pi pi-sign-in",
            iconPos: "left",
            class: "mt-2 w-full",
            disabled: !$setup.valid || $setup.loading,
            loading: $setup.loading,
            onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.doLogin()))
          }, null, 8, ["disabled", "loading"]),
          _cache[7] || (_cache[7] = _createElementVNode("p", { class: "!mt-6 text-center text-xs font-semibold text-slate-500" }, null, -1))
        ])
      ])
    ])
  ]))
}